import { render, staticRenderFns } from "./EntyPropertiesRow.vue?vue&type=template&id=e940b21e&scoped=true&"
import script from "./EntyPropertiesRow.vue?vue&type=script&lang=js&"
export * from "./EntyPropertiesRow.vue?vue&type=script&lang=js&"
import style0 from "./EntyPropertiesRow.vue?vue&type=style&index=0&id=e940b21e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e940b21e",
  null
  
)

export default component.exports